import styled from 'styled-components';

import Field from 'components/form/readyInputs';

export const StyledField = styled(Field)`
  display: flex;

  margin-bottom: 5px;
  align-items: center;
  label {
    font-size: 13px;
    width: 180px;
    line-height: 1;
    padding: 0 1rem 0 0;
    margin: 0;
  }
  & input,
  & > select,
  & > div {
    font-size: 13px;
    padding: 3px 5px;
    border: none;
    background: ${(props) => (props.error ? '#fff0f0' : '#fff')};
    color: #000;
    width: 180px;
    height: 25px;
    line-height: 25px;
    border-bottom: 1px solid rgba(255, 255, 255, 1);
    transition: 0.2s all ease-in;
    &:focus {
      outline: none;
      border-bottom-color: rgba(200, 200, 200, 1);
    }
  }
  & > select,
  & > div {
    padding-left: 0;
  }
`;

export const Container = styled.div`
  padding: 16px;
  box-sizing: border-box;
  background: #fff;
  color: #000;
  position: absolute;
  max-width: 480px;
  left: 0;
  top: 35px;
  border-radius: 16px;
  z-index: 100;
`;

export const Title = styled.h2`
  margin: 0 0 2rem;
  font-weight: bold;
`;

export const Buttons = styled.div`
  display: flex;
  margin: 32px 0 0;
  justify-content: flex-start;
  & > button {
    margin-right: 1rem;
  }
`;

export const ErrorMsg = styled.div`
  color: #933;
  margin: 1rem 0;
`;
